import styled from 'styled-components';
import { key } from 'styled-theme';

export default styled.p`
  margin: 16px auto 0 auto;
  text-align: center;

  a {
    color: ${key('colors.blue.default')};
    text-decoration: none;
    font-weight: 500;
  }
`;
